<template>
    <div>
        <page-header :header-title="` `" :header_logo="true" :header_side="true">
            <button slot="headerBtns" class="h_search_btn" @click="$router.push('/search')"></button>
        </page-header>
        <page-header class="sub_header" :header-title=" $t('collect_search') "></page-header>
        <div class="pl10 pr10">
            <collect-list-component :collect-type="'searchCollect'"></collect-list-component>
        </div>
    </div>
</template>

<script>

import CollectListComponent from "@/components/collect/CollectListComponent";

export default {
    name: "SearchResultCollect",
    mixins: [],
    components: {
        CollectListComponent,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
